import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=188b1200"
import script from "./ActionMenu.vue?vue&type=script&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports